module.exports = __webpack_public_path__ + "img/orange-header-zh.a7e9bf39.png";